//#region IMPORT
import Commons from '../../../Services/Common/Common';
import Global from '../../../Services/Common/Global';
import { showSnackbar } from '../../../Reducer/SnackbarReducer';
import dayjs from 'dayjs';
//#endregion

/**
 * 보호구 관리 - 보호구 관리대장 (PPE_BASIC_02) 전용 로직
 * other 케이스에서 사용
 */

// 사진 가져오기 함수
const SearchPhoto = async (sign, imgRef) => {
  try {
    if (!sign) {
      imgRef.current = '';
      return;
    }

    await Commons.Axios(
      'post',
      Global.base.useUrl + Global.urls.Execute.ftpResponse,
      {
        value1: Commons.EncryptAES(sign),
      }
    ).then((result) => {
      let data = result.data;
      if (data !== 'Error') {
        imgRef.current = `data:image/png;base64,${data}`;
      } else {
        imgRef.current = '';
      }
    });
  } catch (e) {
    console.error('SearchPhoto 실패:', e);
    imgRef.current = '';
  }
};

// 보호구 관리대장 인쇄 함수
export const PrintLogic1 = async (
  documentData, // documentData는 사용하지 않지만 시그니처 통일을 위해 유지
  dispatch,
  setLoading,
  originalRowData1,
  depList,
  memberList,
  user,
  searchRef,
  imgRef
) => {
  if (!originalRowData1 || originalRowData1.length === 0) {
    dispatch(
      showSnackbar({
        message: '인쇄할 데이터가 없습니다.',
        type: 'warning',
      })
    );
    return null;
  }

  setLoading(true);
  try {
    // 그룹 행 제외하고 실제 데이터 행만 필터링
    const tableData = originalRowData1
      .filter((row) => !row.isGroupRow)
      .map((row, index) => {
        // 부서명 (camelCase 필드명 사용) - 명을 우선 사용
        const depName = row.depNmLast || row.managerDepartment || '';

        // 담당자명 (camelCase 필드명 사용) - 명을 우선 사용
        const memberName = row.managerName || row.managerId || '';

        // 날짜 형식 변환 (camelCase 필드명 사용)
        const isIn = row.inQty || 0 > 0;
        const isOut = row.outQty || 0 > 0;
        const inDate = isIn ? row.moveDate : null;
        const outDate = isOut ? row.moveDate : null;

        const inDateStr = inDate ? dayjs(inDate).format('YYYY-MM-DD') : '';
        const outDateStr = outDate ? dayjs(outDate).format('YYYY-MM-DD') : '';

        // 레포트 양식에 맞게 데이터 매핑 (영문 필드명 사용)
        // 천단위 구분 기호 추가 함수
        const formatNumber = (value) => {
          if (value == null || value === '') return '0';
          const num = typeof value === 'number' ? value : Number(value);
          return isNaN(num) ? '0' : num.toLocaleString('ko-KR');
        };

        return {
          NO: index + 1,
          EQUIP_NM: row.equipNm || '',
          UNIT: row.unit || '',
          SPEC: row.spec || '',
          PAYMENT_STANDARD: row.paymentStandard || '',
          PRICE: formatNumber(row.price),
          IN_DATE: inDateStr,
          IN_QTY: formatNumber(row.inQty),
          OUT_DATE: outDateStr,
          OUT_QTY: formatNumber(row.outQty),
          CURR_QTY: formatNumber(row.currentQty),
          MANAGER_DEPARTMENT: depName,
          MANAGER_ID: memberName,
          REMARK: row.remark || '',
        };
      });

    // 검색 연월 추출 (currentYear, month 사용)
    const currentYear = searchRef?.current?.currentYear;
    const currentMonth = searchRef?.current?.month;
    let year = '';
    let month = '';

    if (currentYear && currentMonth) {
      year = currentYear.toString();
      month = currentMonth.toString();
    } else {
      // 날짜가 없으면 현재 년월 사용
      const now = new Date();
      year = now.getFullYear().toString();
      month = String(now.getMonth() + 1).padStart(2, '0');
    }

    const printData = {
      FileName: 'PPE_BASIC_04',
      HeaderData: JSON.stringify({
        YEAR: year,
        MONTH: month,
        CUST_NM:
          searchRef?.current?.custList?.filter(
            (e) => e.value === searchRef?.current?.custCd
          )[0]?.custNm || '',
        USER_NM: user?.userNm || '',
        USER_SIGN: !imgRef.current
          ? ''
          : imgRef.current.replace(/^data:image\/[a-z]+;base64,/, ''),
      }),
      TableData: JSON.stringify(tableData),
    };

    const response = await Commons.Axios(
      'report',
      Global.base.useUrl + Global.urls.Reports.reports,
      printData
    );

    // response.data가 blob인 경우 그대로 반환
    if (response.data instanceof Blob) {
      return response.data;
    }
    // response.data가 다른 형태인 경우 blob으로 변환
    else if (response.data) {
      return new Blob([response.data], { type: 'application/pdf' });
    } else {
      console.error('PrintLogic1: 응답 데이터가 없습니다.');
      return null;
    }
  } catch (e) {
    console.error(e);
    dispatch(
      showSnackbar({
        message: e.message || '인쇄 데이터 생성에 실패했습니다.',
        type: 'error',
      })
    );
    return null;
  } finally {
    setLoading(false);
  }
};
